import { Injectable } from '@angular/core';

import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler
} from '@angular/common/http';

import { mergeMap } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { AuthService } from './auth.service';
import { SettingsService } from '../firestore/settings.service';

// https://www.google.com/search?q=angular+how+get+user+token+for+firebase+in+interceptor&spell=1&sa=X&ved=2ahUKEwiupYWfgJD6AhV8rJUCHUFRA4MQBSgAegQIARA7&biw=1536&bih=722&dpr=1.25
// https://stackoverflow.com/questions/51053699/interceptor-with-firebase-authentication

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  //localAuth: Auth;

  constructor(private authService: AuthService, private settingsService: SettingsService) {
    //this.localAuth = getAuth();
  }

 intercept(req: HttpRequest<any>, next: HttpHandler) {
    let modifiedRequest;

    if (
         (req.url.indexOf(this.settingsService.getCloudFunctionsUrl() + '/proxy') == 0) ||
         (req.url.indexOf('http://localhost:5000/wlremember-bb01a/us-central1/proxy') == 0) ||
         (req.url.indexOf(this.settingsService.getCloudFunctionsUrl() + '/api') == 0) ) {

      // pega o token
      // pega o token
      // const userToken =  await getAuth().currentUser.getIdToken()

      /*
      return this.auth.idToken.pipe(
        mergeMap((token: any) => {
          console.log(token);
          if (token) {
            req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
          }

          return next.handle(req);

      }));*/

      const token = this.authService.userToken;

      if (token)
        req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });

      return next.handle(req);

    } else {
      console.log('Outgoing request');
      console.log("urlll " + modifiedRequest.url);
      console.log(modifiedRequest.headers);
      //return next.handle(modifiedRequest);
      return next.handle(modifiedRequest);
    }
  }
}

